import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { showManualLinkHandlingSelector } from '@/state/config';
import { useController } from './useController';
/**
 * Custom hook to handle links manually by preventing the default click
 * behavior and notifying the application of the link click event.
 */
export const useHandleLinksManually = () => {
    const handleLinksManually = useRecoilValue(showManualLinkHandlingSelector);
    const { notifyLinkClicked } = useController();
    const handleLinkClick = useCallback((event) => {
        const isLink = event.target.tagName.toLowerCase() === 'a';
        if (handleLinksManually && isLink) {
            event.preventDefault();
            notifyLinkClicked(event.target.href);
        }
    }, [handleLinksManually, notifyLinkClicked]);
    return {
        handleLinkClick,
    };
};
